const BannerData = {
  // imageUrl:
  //   "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2FCarensPremium.avif?alt=media&token=77a0cb36-cc95-4133-bb9c-a8d52f48edb0",
  // title: "Kia Carens",
  // subtitle: "From a diffrent world.",
  // price: "₹10,99,159*",
  // features: [],

   videoUrl:
    "",
  imageUrl:
  "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarensPremium.webp?alt=media&token=399a499f-22e5-4e66-a221-f3147c19a03d",
  title: "Kia Carens",
  subtitle: "From a diffrent world.",
  price: "₹10,99,159*",
  

  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fico_1.webp?alt=media&token=7a46c90c-bc3c-4d38-a00d-1063cc6cf998",
      text: "Robust 15 Hi-safety features",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fico_2.webp?alt=media&token=6d23057c-b0d0-4199-aa91-25b187ce3cb3",
      text: "2nd Seat One Touch Easy Electric Tumble",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fico_3.webp?alt=media&token=20928f8b-6087-44d2-ada7-efd3acc4e723",
      text: "20.32 cm(8.0)Touchscreen",
    },
  ],
};

const banner2Data = {
  imgSrc:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fimage1.jpg?alt=media&token=43d30c4d-5416-4ef1-a3b5-4048d114005e",
  data: [
    {
      title: "iMT (Intelligent Manual Transmission)",
      description:
        "",
    },
    {
      title: "Standard 6 Airbags",
      description: "",
    },
    {
      title: "Bose Premium Sound System with 8 Speakers",
      description: "",
    },
  ],
};

const IntroData = {
  heading: "The futuristic journey begins",
  subheading: "Welcome to a world of infinite choices",
  description:
    "Future calls out to those who are from a different world. The Kia Carens is hi-tech by design and inspiring by nature. It is futuristic sophistication clothed in bold and edgy armor with many class-leading features. So get ready to step into a different world.",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2FCarens-BS-1.jpg?alt=media&token=d5d3da3b-57b0-472e-845b-48e0ac5df087",
};

const InterestDealerData = {
  disclaimer: "",
  register:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2Fregister%20intrest.png?alt=media&token=2c5fb2a2-418b-4399-8994-8e590bd17314",
  dealer:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FBrochure%20image.png?alt=media&token=5ce8b8e6-2d25-41f1-b458-69aa2bd51a10",
};
const CarouselData = [
  {
    sub: "Gravity",
    title: "Step Into a World Beyond.",
    data: "The Carens Gravity Variant invites you to explore a world where luxury and innovation meet. With design, tech, and a driving experience that transcends the every day, it truly is from a different world.​​",
    carData: [
      {
        title: "Dash Cam with Dual Camera",
        description:
          "Capture every moment from all angles, ensuring your journey is watched over with clarity and precision.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fgravity1.webp?alt=media&token=56b355ac-c3a1-4970-b687-be67e925a7a6",
      },
      {
        title: "Black Leatherette Seats",
        description:
          "Sink into sleek, sophisticated comfort that enhances every mile of your adventure.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fgravity2.webp?alt=media&token=03f7eb4b-4b60-4df8-bc80-5f54a6645c36",
      },
      {
        title: "Skylight Sunroof",
        description:
          "Open up to endless possibilities as the scenic view elevates your drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fgravity3.webp?alt=media&token=97e2a50e-2363-4e64-adde-fc14b5daa67e",
      },
      {
        title: "D-Cut Steering Wheel",
        description:
          "Experience refined control with a modern design that adds a touch of precision to every turn.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fgravity4.webp?alt=media&token=c9a6ad79-90a9-43f5-ad38-c1a03698aee8",
      },
      {
        title: "Gravity Emblem",
        description:
          "Wear the emblem of distinction, marking your journey as one that’s from a different world.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fgravity5.webp?alt=media&token=8cce1789-fdee-435b-96ca-d5740d93ef03",
      },
    ],
  },
  {
    sub: "X-Line",
    title: "X from a different world",
    data: "Take all the great things the Kia Carens has to offer and get ready to be transported to a different world.Right from the xclusive matte graphite to the space-age cockpit with sage green upholstery and rear seat entertainment screen, the Carens X-line is crafted to immerse you into a different world of style and comfort.​​",
    carData: [
      {
        title: "Stylish matte graphite exterior and black glossy grille",
        description: "Make you stand out in the world",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fx1.webp?alt=media&token=de397e26-531d-4dea-a0a4-e5327279941f",
      },
      {
        title: "G1.5 Turbo Petrol Engine with 160 ps power",
        description: "Delivers unmatched power for your family trips​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fx2.webp?alt=media&token=a8f7cf66-e7a5-4167-8dc8-a2ec303305ce",
      },
      {
        title: "Rear seat entertainment screen",
        description: "Gives freedom to choose your entertainment",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fx3.webp?alt=media&token=c0e85af5-6313-41da-923d-a5126ff14bc4",
      },
      {
        title:
          "Futuristic interiors with 3-rows, captain seats and walk in lever",
        description:
          "Offers more legroom and comfort, available in Kia 6 and 7 seater car options in India, which is class-leading",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fx4.webp?alt=media&token=01d6a24e-f319-473c-8d6e-dc56ea3cc8d0",
      },
      {
        title: "Kia Connect Skills with Amazon Alexa",
        description: "Lets you control your Kia from the comfort of your home",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarens%252Fx5.webp?alt=media&token=3fbaf7f4-c4dc-4713-9f8a-4176b1bd3ca7",
      },
    ],
  },
];
const CarouselData1 = [
  {
    sub: "EXTERIOR",
    title: "A world of bold and captivating style",
    data: "The distinctive style of Kia Carens inspires awe and respect at the same time. Just like you, this car commands instant attention.It has been designed with bold attitude and space-age sophistication to offer experiences from a different world.​",
    carData: [
      {
        title: "Star Map LED DRLs with Crown Jewel LED Headlamps",
        description:
          "Inspired by constellations, the Star Map LED DRLs are crafted to enhance forward visibility, while the Crown Jewel LED Headlamps lend a distinctive visual edge through avant-garde design.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext1.webp?alt=media&token=e763f243-d11d-4606-9b84-0c9d14edc41c",
      },
      {
        title: "Star Map LED Tail Lamps",
        description:
          "Leave a starry trail wherever you go with the Star Map LED Tail Lamps—a perfect fusion of form and finesse, drawing inspiration from a million stars for its breathtaking aesthetic appeal.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext2.webp?alt=media&token=c8424b7b-2e35-4585-abd5-485241543dd6",
      },
      {
        title: "R16 – 40.62 cm (16’’) Dual Tone Crystal Cut Alloy Wheels",
        description:
          "Chiselled to enhance its distinctive appeal, the dual-tone finish lends a sporty and premium look to the assertive crystal-cut glossy alloy wheels.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext3.webp?alt=media&token=baca7571-cd62-492a-8edb-5278aab1232a",
      },
      {
        title: "Kia Signature Tiger Face with Digital Radiator Grille",
        description:
          "An edge from a different world. Kia's Signature Tiger Face, accompanied by the Digital Radiator Grille, captivates attention with its refreshing style and contrasting attitude.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext4.webp?alt=media&token=e9e4ba06-71f2-4c01-8be4-148acca4bb0c",
      },
      {
        title: "Chrome Rear Bumper Garnish with Diamond Knurling Pattern",
        description:
          "The chrome cast intricate design adds a touch of sophistication to the rear, creating a stunning visual appeal.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext5.webp?alt=media&token=eeb2005a-d1bc-4ae9-9782-db23a6a34de3",
      },
      {
        title: "Sky Light Sunroof",
        description: "Think of it as your portal to a different world.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fext6.webp?alt=media&token=6156852b-bbc4-4a39-bd04-18ce7e232366",
      },
    ],
  },
  {
    sub: "INTERIOR",
    title: "A world of intuitive and immersive experiences",
    data: "When you look within yourself, you are truly limitless. The Kia Carens is an ode to that spirit. Right from the spacecraft-like plush seats to the wraparound high-tech dashboard, every detail of the Kia Carens is crafted perfectly to immerse you in a different world of advancement.",
    carData: [
      {
        title: "Dashcam with Dual Camera",
        description:
          "Enhanced safety, security and convenience with dual recording typically positioned to record both the road ahead and the interior of the Kia Carens.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fint-1-d.webp?alt=media&token=12fc3c3c-b7ea-4609-a53c-788438e3ba07",
      },
      {
        title: "26.03 cm (10.25’’) HD Touchscreen Navigation",
        description:
          "The ideal and futuristic way to stay entertained, navigate, and stay connected with the world.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fint-4-d.webp?alt=media&token=1e74401f-7cc6-48f9-937a-db336f777a19",
      },
      {
        title: "BOSE Premium Sound System with 8 Speakers",
        description:
          "Set the mood right and make every journey epic with an unparalleled audio experience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fint-5-d.webp?alt=media&token=91434cbb-7ea3-4a50-9a36-17dd90054765",
      },
      {
        title: "Cabin Surround 64-Color Ambient Mood Lighting",
        description: "Every possible shade to match every possible mood.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fint-7-d.webp?alt=media&token=0ede232f-ca72-48d5-91c6-a70f1ea86001",
      },
      {
        title: "Ventilated Front Seats",
        description:
          "Keep it cool as it gets hot outside with the Ventilated Front Seats that make you feel like you are in steering your way through the",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fint-8-d.webp?alt=media&token=20a5f9c2-ee0f-4dcd-b98a-d8b34a4ada18",
      },
      // {
      //   title: "Smart Pure Air Purifier with Virus & Bacteria Protection**",
      //   description:
      //     "Clean cabin-air with protection from harmful virus and bacteria.",
      //   media:
      //     "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fint-1-d.avif?alt=media&token=14429b27-285a-4fa5-82ee-2c7f77b097ed",
      // },
    ],
  },
  {
    sub: "PERFORMANCE",
    title: "A world where adrenaline does the talking",
    data: "Excitement seeks those who seek power. Level up your driving experience with the smartstream powertrain, delivering unmatched power and performance.",
    carData: [
      {
        title: "Powerful Smartstream 1.5l T-GDi Petrol Engine",
        description:
          "Unleash the true potential of your drive with the powerful smartstream technology. Transform your journey with G1.5L T-GDi Petrol Engine, delivering the power and performance your drive deserves.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fper1.webp?alt=media&token=07272075-7221-4e66-866e-5015810f9ae4",
      },
      {
        title: "Advanced Smartstream 1.5l Petrol Engine",
        description:
          "Powerful journeys are always inspiring but, this time we are unlocking a new level of power with the advanced smartstream technology. The 1.5l Petrol Engine delivers powerful performance where adrenaline does the talking with boosted power and torque.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fper2.webp?alt=media&token=e0823181-f7e6-406a-b39c-397101cb6807",
      },
      {
        title: "Refined 1.5l CRDi VGT Diesel Engine",
        description:
          "Your unstoppable journey begins when you find inspiration. With the Refined 1.5L CRDi VGT Diesel Engine, experience a drive that redefines excellence and takes your travel to newer heights.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fper3.webp?alt=media&token=59730385-217e-4005-b912-113ba983c985",
      },
    ],
  },
  {
    sub: "CONVENIENCE",
    title: "A world where comfort is everything",
    data: "Space is what inspires you to be truly you. That’s why the Carens offers you class-leading cabin space with plush 3-row seating comfort in 6 & 7 seater options to carry your world with you.​",
    carData: [
      {
        title: "2nd Row One Touch Easy Electric Tumble Seat",
        description:
          "Quick & easy way to walk straight to the third row with just a touch of button.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FOne-Touch-d.mp4?alt=media&token=58749a77-2449-40e8-9956-80163c2934ba",
      },
      {
        title: "Roof Flushed 2nd and 3rd Row Diffused AC Vents",
        description:
          "Comfort and convenience come effortlessly with the Carens, featuring first-in-class 2nd and 3rd Row Diffused AC Vents.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcon2.webp?alt=media&token=5ac0692d-c4f7-4137-a2a2-17e6a7722914",
      },
      {
        title: "Smartphone Wireless Charger with Cooling Function",
        description:
          "Designed to wirelessly charge your smartphone with cooling mechanism to prevent overheating during charging. It ensures safe and efficient charging on the go.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcon3.webp?alt=media&token=64715188-8746-4266-bc1b-5d43d6ceb7a9",
      },
      {
        title: "Seat Back Table with Cup Holder and Gadget Mount",
        description:
          "Eat, drink, and savor the journey without any interruptions, thanks to the comfortable Seat Back Table.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcon4.webp?alt=media&token=1290038e-0f31-4676-9523-6daf7daccfb4",
      },
      {
        title: "Cooling Cup & Can Holders",
        description:
          "Keep your refreshments chilled on the go with the Cooling Cup and enjoy designated spots for your beverage containers.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcon5.webp?alt=media&token=4ffad8cf-7c97-4076-aa3f-617b8e262fd3",
      },
    ],
  },
  {
    sub: "SAFETY",
    title:
      "To enhance passenger safety, all variants come standard with 6 airbags.",
    data: "The Kia Carens comes with class-leading Robust 10 Hi-safety features along with many additional features as standard across all variants, making it the safest car in its class. After all, your safety is what drives us to think out of the box.",
    carData: [
      {
        title: "6 Airbags",
        description:
          "To enhance passenger safety, all variants come standard with 6 airbags.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FESC.mp4?alt=media&token=84390042-a91f-4aa8-8f8e-94e0d9b960f0",
      },
      {
        title: "All Wheel Disc Brakes",
        description:
          "Experience an advanced braking system that offers improved safety, control, efficient cooling, consistent performance, and responsive braking on every journey.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fsafe1.webp?alt=media&token=382933a7-a669-41ab-ae5f-e83cd43deca2",
      },
      {
        title: "ESC, VSM, BAS, HAC, DBC & ABS",
        description:
          "Stay in control during slippery or unstable driving conditions with ESC, VSM, BAS, HAC, DBC and ABS features.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fsafe2.webp?alt=media&token=3800908d-cb31-4920-b90c-3f156e544342",
      },
      // {
      //   title: "Highline Tyre Pressure Monitoring System",
      //   description:
      //     "Receive alerts to help the driver monitor tire pressure, enhancing safety, fuel efficiency, and tire longevity.",
      //   media:
      //     "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fsafe4.jpg?alt=media&token=5a64f68a-2dbc-4ed0-b601-632a3c4e91a0",
      // },
    ],
  },
  {
    sub: "CONNECTED",
    title: "Smarter than ever",
    data: "Indulge in a world where the Carens is always at your beck-and-call.Presenting, the next-gen Kia Connect that's integrated with Alexa and offers 66 smart features that you can operate from the comfort of your home.",
    carData: [
      {
        title: "OTA Map & System Update",
        description:
          "Equipped with wireless technology, our advanced navigation and infotainment systems keep you updated with minimal disruption to the driver, ensuring convenience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarens%252Fcar101.webp?alt=media&token=0376dc55-9d89-4827-96c4-f94b07deccc0",
      },
      {
        title: "Voice Controlled Sunroof ",
        description:
          "Now, drivers and passengers can open, close, or adjust the sunroof with simple voice commands.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarens%252Fcar202.webp?alt=media&token=df2bc498-f123-4510-a7b7-5ccb79f853c0",
      },
      {
        title: "Remotely Controlled Ventilated Seats",
        description:
          "Activate the ventilated seats with a remote control to circulate air through the seat surfaces for a more comfortable experience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarens%252Fcar303.webp?alt=media&token=ff168e21-946c-4be0-b5cc-dcfc661d694d",
      },
      {
        title: "Kia Connect Skill on Amazon Alexa",
        description:
          "Studded with numerous smart features, the Kia Carens keeps you connected even when you're not inside. Switch it on and step into a futuristic journey that begins right there.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2FCarens%252Fcar404.webp?alt=media&token=cc6e1d70-03ab-46be-967b-5365be7d0f6b",
      },
    ],
  },
];

const TrimData = [
  // {
  //   title: "Premium 7",
  //   cost: "10,59,900",
  //   feature1: "2nd Seat One Touch Easy Electric Tumble",
  //   feature2: "Roof Flushed 2nd and 3rd Row Diffused AC Vents",
  //   feature3: "Semi Leatherette (Black and indigo) Seats",
  //   feature4: "2nd Row 60:40 Split Seats with Sliding, Reclining and Tumble",
  //   feature5: "3rd Row 50:50 Split Seats with Reclining and Full Flat Folding",
  //   feature6: "Keyless Entry with Burglar Alarm",
  // },
  {
    title: "Premium (O) 7",
    cost: "10,99,159",
    feature1:
      "20.32 cm(8.0)Touchscreen with Android Auto, Apple Carplay,(6 Speakers)",
    feature2: "Semi Leathrette (Black and Indigo Seats)",
    feature3: "Rear view camera with dynamic guideliness",
    feature4:"31.7 cm (12.5) full Segment LCD Cluster with Advanced 10.6cm (4.2) Color TFT MD",
    feature5: "Keyless entry with Burglar Alarm",
    feature6: "Rear view camera with Dynamic Guidelines",
    feature7: "Electric Adjust Outside Mirror with LED Turn Signals",
  },
  // {
  //   title: "Gravity",
  //   cost: "12,29,900",
  //   feature1: "Dash Cam with Dual Camera",
  //   feature2: "Black Leatherette Seats",
  //   feature3: "Skylight Sunroof",
  //   feature4: "D-Cut Steering Wheel",
  //   feature5: "Rear View Camera with Dynamic Guidelines",
  //   feature6: "Keyless Entry with Burglar Alarm",
  //   feature7:
  //     "20.32 cm (8.0) Touchscreen with Android Auto, Apple Carplay (6 Speakers)",
  // },
  // {
  //   title: "Prestige",
  //   cost: "14,25,900",
  //   feature1:
  //     "20.32 cm (8.0) Touchscreen with Android Auto, Apple Carplay (6 Speakers)",
  //   feature2: "Premium Fabric and Leatherette Combination (Black ) Seats",
  //   feature3: "Rear View Camera with Dynamic Guidelines",
  //   feature4: "Front Parking Sensors",
  //   feature5: "Keyless Entry with Burglar Alarm",
  //   feature6: "Electric Adjust Outside Mirror with LED Turn Signals",
  // },
  // {
  //   title: "Prestige (O) 6",
  //   cost: "11,99,900",
  //   feature1:
  //     "Premium Fabric and Leatherette Combination (Black and Beige Seats)",
  //   feature2: "Rear view camera with Dynamic Guideliness",
  //   feature3: "Front Parking Sensors",
  //   feature4: "Smart Key with push button start",
  //   feature5: "Electric Adjust Outside Mirror with LED Turn Signals",
  //   feature6: "Star map LED DRLs and Tailamps",
  // },

  // {
  //   title: "Prestige Plus 7",
  //   cost: "15,19,900",
  //   feature1: "Star Map LED DRLs and Tailamps",
  //   feature2: "R16 - 40.62 cm (16”) Dual Tone Crystal Cut Alloy Wheels",
  //   feature3: "Fully Automatic Air Conditioner",
  //   feature4: "Multi Drive Modes (Normal/Eco/Sport) [7DCT]",
  //   feature5: "Smart Key with Push Button Start",
  //   feature6: "Auto Cruise Control with Speed Limiting Option",
  //   feature7: "Remote Engine Start",
  // },
  // {
  //   title: "Prestige Plus(O)",
  //   cost: "16,39,900",
  //   feature1: "Sky Light sunroof",
  //   feature2: "Star Map LED DRls and Tailamps",
  //   feature3: "Fully Automatic Air Conditioner",
  //   feature4: "Smart Key with Push Button Start",
  //   feature5: "Rear Door with Sunshade Curtains",
  //   feature6: "Cooling Cup and Can Holders",
  // },
  // {
  //   title: "Luxury Plus",
  //   cost: "18,99,900",
  //   feature1: "Sky Light Sunroof",
  //   feature2: "BOSE Premium Sound System with 8 Speakers",
  //   feature3: "Ventilated Front Seats",
  //   feature4:
  //     "2nd Row Captain Seats with Sliding, Reclining and Tumble [6 Seater]",
  //   feature5: "Smart Phone Wireless Charger with Cooling Function",
  //   feature6: "Paddle Shifters [7DCT/6AT]",
  //   feature7:
  //     "Ambient Lighting linked with Multi-Drive Modes (Normal/Eco/Sport) [DCT/AT]",
  // },
  // {
  //   title: "X-Line 6",
  //   cost: "19,49,900",
  //   feature1: "Xclusive X-Line styling",
  //   feature2: "25.65cm (10.1)Rear Seat Entertainment-Passenger side",
  // },
];

const CircleData = [
  {
    title: "Imperial Blue",
    color: "#2b2c71",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcarens1.webp?alt=media&token=9e845440-f2be-4657-8f88-5176f184e931'
  },
  // {
  //   title: "Intense Red",
  //   color: "#b2001e",
  //   imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fcarns2.png?alt=media&token=416024b3-db63-41a8-8659-13f355c33bee'
  // },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcarens3.webp?alt=media&token=8ee66ebd-ac7c-41f5-92c0-402948bd3620'
  },
  {
    title: "Sparkling Silver",
    color: "#e0e0df",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fcarens4.png?alt=media&token=17ed0f96-3f1b-4039-877a-72ab347b956e'
  },
  {
    title: "Gravity Grey",
    color: "#444444",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fcarens5.png?alt=media&token=96916bad-f7f4-464f-9b24-32728843c135'
  },
  {
    title: "Clear White",
    color: "#f3f9fb",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens%2Fcarens6.webp?alt=media&token=2388731d-78c0-437b-93b3-178993564ea3'
  },
  {
    title: "Pewter Olive",
    color: "#121e0f",
    imgSrc: 'https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carens%2Fcarens7.png?alt=media&token=3561e7cf-2f52-4046-b7c1-6812d2d2411c'
  },
];

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book Kia Carens Today ",
    desc: "Exprience a diffrent World",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Know it all about our Big Family Car",
    link: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/showroom/Carens/Carens_Brochure_2025_Desktop.pdf",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];

// const FaqData = [
//   {
//     question: "What is the price of Kia Carens?",
//     answer: "Kia Carens MSRP* starts at ₹ 10 59 900* (exclusive of all taxes).",
//   },
//   {
//     question: "Does the Kia Carens come with a sunroof?",
//     answer:
//       "Yes, selected variants of Kia Carens top model comes with a sunroof.",
//   },
//   {
//     question: "What are the seating options available in the Kia Carens?",
//     answer:
//       "The Carens provides best-in-class cabin space, along with luxurious 3-row seating comfort, in Kia's 6 and 7-seater car options in India, allowing you to take your world with you wherever you go.",
//   },
//   {
//     question: "How many airbags are there in Kia Carens?",
//     answer:
//       "Kia Carens is a family car that offers 6 airbags to ensure comprehensive safety for you and your loved ones.",
//   },
//   {
//     question: "What are the transmission options available in the Kia Carens?",
//     answer:
//       "The all-new Kia Carens is available in both manual and automatic transmissions, namely – 7DCT, 6AT and 6 MT, 6iMT.",
//   },

//   {
//     question: "Which Kia carens model has a sunroof?",
//     answer:
//       "Kia Carens Sunroof Models are Prestige+(O), Luxury and Luxury Plus. These selected top models feature a skylight sunroof for enhanced openness and ambiance.",
//   },
// ];

const StepData = [
  {
    title: "Star Map LED DRLs with Crown Jewel LED Headlamps",
    desc: "For a sleek and futuristic look that lends Carens a distinct identity.Inspired by constellations, they lend a distinctive visual edge through sleek and avant-grade design.",
  },
  {
    title: "R16 - 40.62 CM (16”) Dual Tone Crystal Cut Alloy Wheels ",
    desc: " Designed to stun, even at standstill. Chiselled to stun and enhance the muscular appeal, the two-tone finish provides a sporty and premium look.",
  },
  {
    title: " Chrome Rear Bumper Garnish with Diamond Knurling Pattern",
    desc: " It's a statement cast in chrome. Keep distance.Eye-catching bumper designed with chrome and sophisticated pattern makes the rear look stunning.",
  },
  {
    title: "Sky Light Sunroof",
    desc: "Think of it as your portal to a different world.",
  },
  {
    title: "26.04 cm (10.25”) Full Digital Color Cluster",
    desc: "Enhance your driving experience with a clear and concise display of vehicle parameters.",
  },
  {
    title: "Ventilated Front Seats",
    desc: "This is what the lap of luxury looks like. With days getting hotter, the driving experience gets cooler while lounging in the lap of luxury.",
  },
];

export {
  CarouselData,
  CarouselData1,
  TrimData,
  CircleData,
  DetailInfo,
  // FaqData,
  StepData,
  BannerData,
  IntroData,
  InterestDealerData,
  banner2Data
};
